import axios from 'axios';
import qs from 'qs';

const domain = axios.create({
    baseURL: typeof URL_ACCESS_RESOLUTION_API !== 'undefined' ? URL_ACCESS_RESOLUTION_API : URL_DOMAIN_API
});

domain.interceptors.request.use((request) => {
    request.headers.Authorization = localStorage.getItem('token');
    return request;
}, error => Promise.reject(error));

const getIssues = ({body}) => domain.post('accessResolution/getIssues', qs.stringify(body));
const getLogins = ({body}) => domain.post('accessResolution/getLogins', qs.stringify(body));
const getWhitelisted = ({body}) => domain.post('accessResolution/getWhitelisted', qs.stringify(body));
const executeAction = ({body}) => domain.post('accessResolution/executeAction', qs.stringify(body));
const getGuidance = ({body}) => domain.post('accessResolution/getGuidance', qs.stringify(body));
const search = ({body}) => domain.post('accessResolution/search', qs.stringify(body));

export default {
    getIssues,
    getLogins,
    getWhitelisted,
    executeAction,
    getGuidance,
    search
};
